/**
 * CSP region -> parent region (the collapse tier). From CSP's csp-region-meta.json;
 * the backend carries the same map in lib/cspRegionParents.json.
 */
export const CSP_REGION_PARENTS: Record<string, string> = {
  "Cascade Range Foothills — foothills & hills": "Cascade Range",
  "Central Coast — coastal terraces & valleys": "Central Coast",
  "Central Coast — foothills & hills": "Central Coast",
  "Central Coast — mountains & forests": "Central Coast",
  "Central High Sierra Nevada — high peaks & subalpine": "Sierra Nevada (High)",
  "Diablo Range": "South Coast Ranges",
  "East of Sierra Nevada — foothills & hills": "East of the Sierra & Great Basin",
  "East of Sierra Nevada — mountains & forests": "East of the Sierra & Great Basin",
  "East of Sierra Nevada — valleys & basins": "East of the Sierra & Great Basin",
  "Foothill Ridges and Valleys": "Northern Coast Ranges",
  "High Cascade Range — foothills & hills": "Cascade Range",
  "High Cascade Range — mountains & forests": "Cascade Range",
  "High Cascade Range — valleys & basins": "Cascade Range",
  "High North Coast Ranges — mountains & forests": "Northern Coast Ranges",
  "Inner North Coast Ranges — foothills & hills": "Northern Coast Ranges",
  "Inner North Coast Ranges — mountains & forests": "Northern Coast Ranges",
  "Inner North Coast Ranges — valleys & basins": "Northern Coast Ranges",
  "Inner South Coast Ranges — foothills & hills": "South Coast Ranges",
  "Inner South Coast Ranges — mountains & forests": "South Coast Ranges",
  "Inner South Coast Ranges — valleys & basins": "South Coast Ranges",
  "Klamath Ranges — east-slope mountains": "Klamath Ranges",
  "Klamath Ranges — foothills & hills": "Klamath Ranges",
  "Klamath Ranges — high peaks & subalpine": "Klamath Ranges",
  "Klamath Ranges — valleys & basins": "Klamath Ranges",
  "Klamath Ranges — west-slope mountains": "Klamath Ranges",
  "Marin Hills": "San Francisco Bay Area",
  "Modoc Plateau — foothills & hills": "Modoc Plateau & Northeast",
  "Modoc Plateau — mountains & forests": "Modoc Plateau & Northeast",
  "Modoc Plateau — valleys & basins": "Modoc Plateau & Northeast",
  "Mojave Desert — basins, playas & low ranges": "Mojave Desert",
  "Mojave Desert — foothills & hills": "Mojave Desert",
  "Mojave Desert — mountains & high elevation": "Mojave Desert",
  "North Coast — coastal terraces & valleys": "North Coast",
  "Northern Channel Islands": "Channel Islands",
  "Northern High Sierra Nevada — mountains & forests": "Sierra Nevada (High)",
  "Northern High Sierra Nevada — valleys & basins": "Sierra Nevada (High)",
  "Northern Sierra Nevada Foothills — foothills & hills": "Sierra Nevada Foothills",
  "Outer North Coast Ranges — mountains & forests": "Northern Coast Ranges",
  "Outer North Coast Ranges — valleys & basins": "Northern Coast Ranges",
  "Outer South Coast Ranges — foothills & hills": "South Coast Ranges",
  "Outer South Coast Ranges — mountains & forests": "South Coast Ranges",
  "Outer South Coast Ranges — valleys & basins": "South Coast Ranges",
  "Peninsular Ranges — foothills & hills": "Peninsular Ranges",
  "Peninsular Ranges — mountains & high elevation": "Peninsular Ranges",
  "Sacramento Valley — foothills & hills": "Sacramento Valley",
  "Sacramento Valley — valleys & basins": "Sacramento Valley",
  "San Bernardino Mountains — high peaks & subalpine": "Transverse Ranges",
  "San Francisco Bay Area — foothills & hills": "San Francisco Bay Area",
  "San Joaquin Desert": "San Joaquin Valley",
  "San Joaquin Valley floor": "San Joaquin Valley",
  "Santa Maria/Santa Ynez Valleys": "South Coast Ranges",
  "Sierra Nevada-Influenced Semiarid Hills and Basins": "Modoc Plateau & Northeast",
  "Sonoran Desert — basins, playas & low ranges": "Sonoran / Colorado Desert",
  "Sonoran Desert — foothills & hills": "Sonoran / Colorado Desert",
  "Sonoran Desert — mountains & high elevation": "Sonoran / Colorado Desert",
  "South Coast — coastal terraces & valleys": "Southern California Coast",
  "South Coast — foothills & hills": "Southern California Coast",
  "Southern Cascades Foothills": "Cascade Range",
  "Southern Channel Islands": "Channel Islands",
  "Southern High Sierra Nevada — mountains & forests": "Sierra Nevada (High)",
  "Southern High Sierra Nevada — valleys & basins": "Sierra Nevada (High)",
  "Southern Sierra Nevada Foothills — foothills & hills": "Sierra Nevada Foothills",
  "Southern Sierra Nevada Foothills — mountains & high elevation": "Sierra Nevada Foothills",
  "Southern Sierra Nevada Foothills — valleys & basins": "Sierra Nevada Foothills",
  "Tehama Terraces": "Northern Coast Ranges",
  "Upper Coachella Valley and Hills": "Sonoran / Colorado Desert",
  "Warner Mountains — mountains & forests": "Modoc Plateau & Northeast",
  "Western Traverse Ranges — foothills & hills": "Transverse Ranges",
  "Western Traverse Ranges — mountains & forests": "Transverse Ranges",
  "Western Traverse Ranges — valleys & basins": "Transverse Ranges",
  "White and Inyo Mountains — mountains & forests": "East of the Sierra & Great Basin",
};
